import {NormalizerI} from './normalizer.i';
import {isString, isNumber, includes, findIndex} from 'lodash';

const DOT = '.';
const ZERO = '0';
const EMPTY = '';
const availableSymbolsReg = /[^0-9.]/g;
const digitsReg = /[^0-9]/g;

export class FloatNormalizer implements NormalizerI {

    normalize(value: string): string {
        if (!isString(value)) {
            if (isNumber(value)) {
                value = Number(value).toString();
            } else {
                return EMPTY;
            }
        }

        var availableSymbols = value.replace(availableSymbolsReg, EMPTY);

        if (availableSymbols.length > 0) {

            if (includes(value, DOT)) {
                let dotIndex = findIndex(availableSymbols, val=>val === '.');
                if (dotIndex == 0) {
                    availableSymbols = ZERO + DOT
                        + (availableSymbols.substring(dotIndex + 1, availableSymbols.length).replace(digitsReg, EMPTY));
                } else {
                    availableSymbols = availableSymbols.substring(0, dotIndex + 1)
                        + (availableSymbols.substring(dotIndex + 1, availableSymbols.length).replace(digitsReg, EMPTY));
                }
                return availableSymbols;
            } else {
                return availableSymbols;
            }

        } else {
            return EMPTY;
        }
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/normalizers/float.normalizer.ts